import React from "react";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import LoadingStates from "../../constants/states/LoadingStates";
import CheckoutViewStore from "../../stores/CheckoutViewStore";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import CheckoutView from "../views/CheckoutView";
import SavingStates from "../../constants/states/SavingStates";
import LoadingView from "../views/LoadingView";

export default class CheckoutContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            "checkoutViewStore": CheckoutViewStore.getState(),
        };
    }

    componentDidMount() {
        this.checkoutViewStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.CHECKOUT_VIEW_STORE_UPDATE, this.handleStoreUpdate);
        EventPublisher.publish(UIInteractionEvents.CHECKOUT_VIEW_MOUNTED, {"id" :this.props.match.params.id})
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.checkoutViewStoreSubscriber);
        EventPublisher.publish(UIInteractionEvents.CHECKOUT_VIEW_UNMOUNTED, {});
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "checkoutViewStore": CheckoutViewStore.getState(),
        });
    };

    render() {
        if (this.state.checkoutViewStore.loadingState === LoadingStates.INITIALIZED ||
            this.state.checkoutViewStore.loadingState === LoadingStates.LOADING
        ) {
            return (
                <LoadingView titleText="Loading Checkout"/>
            );
        }
        if (this.state.checkoutViewStore.loadingState === LoadingStates.FAILED_TO_LOAD) {
            return (
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="alert alert-danger" role="alert">
                                    Sorry we were unable to find the reservation request you are looking for. Please try another one.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <CheckoutView
                isSaving={this.state.checkoutViewStore.savingState === SavingStates.SAVING}
                isPayFailed={this.state.checkoutViewStore.savingState === SavingStates.FAILED_TO_SAVE}
                clientSecret={this.state.checkoutViewStore.stripeClientSecret}
                reservationRequestId={this.state.checkoutViewStore.reservationRequest.reservationRequestId}
                cardInputsValid={this.state.checkoutViewStore.cardInputsValid}
                cardErrorMessage={this.state.checkoutViewStore.cardErrorMessage}
                paymentErrorMessage={this.state.checkoutViewStore.paymentErrorMessage}
                advertisementId={this.state.checkoutViewStore.reservationRequest.advertisementId}
                advertisementTitle={this.state.checkoutViewStore.reservationRequest.advertisementTitle}
                spaceId={this.state.checkoutViewStore.reservationRequest.spaceId}
                spaceTitle={this.state.checkoutViewStore.reservationRequest.spaceTitle}
                startDate={this.state.checkoutViewStore.reservationRequest.startDate}
                endDate={this.state.checkoutViewStore.reservationRequest.endDate}
                pricePerDay={this.state.checkoutViewStore.reservationRequest.pricePerDay}
                amount={this.state.checkoutViewStore.amount}
                taxRate={this.state.checkoutViewStore.taxRate}
                taxesDue={this.state.checkoutViewStore.taxesDue}
                total={this.state.checkoutViewStore.total}
            />
        );
    }

}